/**
 * Sort subway line labels as they should appear within a single station:
 * letters first (alphabetical), then numbers (ascending). The "S" shuttle is
 * placed after the other letters.
 *
 * Examples:
 *   ['R']                              -> ['R']
 *   ['6']                              -> ['6']
 *   ['R', 'N', 'Q']                    -> ['N', 'Q', 'R']
 *   ['3', '1', '2']                    -> ['1', '2', '3']
 *   ['7', 'M', 'B', 'F', 'D']          -> ['B', 'D', 'F', 'M', '7']
 *   ['1','S','W','A','3','Q','2','C','N','R','E'] ->
 *     ['A','C','E','N','Q','R','W','S','1','2','3']
 */
export function sortSubwayLines(lines) {
    return [...lines].sort(compareSubwayLines);
}
function compareSubwayLines(a, b) {
    const aIsNumber = /^\d+$/.test(a);
    const bIsNumber = /^\d+$/.test(b);
    // Letters before numbers.
    if (aIsNumber !== bIsNumber)
        return aIsNumber ? 1 : -1;
    // Both numbers: numeric ascending.
    if (aIsNumber && bIsNumber)
        return Number(a) - Number(b);
    // Both letters: alphabetical, but the "S" shuttle sorts after other letters.
    if (a === 'S' && b !== 'S')
        return 1;
    if (b === 'S' && a !== 'S')
        return -1;
    return a.localeCompare(b);
}
